webpackJsonp([1],{

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(8);





var instance = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({ baseURL: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.server });

/* harmony default export */ __webpack_exports__["a"] = ({
  getUsuarios: function getUsuarios() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return instance.get("/users/getall").then(function () {
                var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response) {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return response.data;

                        case 2:
                          return _context.abrupt("return", _context.sent);

                        case 3:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, _this);
                }));

                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }(), function (error) {
                console.log(error);
              });

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }))();
  },
  getContatos: function getContatos() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return instance.get('/contatos/get').then(function () {
                var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(response) {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return response.data;

                        case 2:
                          return _context3.abrupt("return", _context3.sent);

                        case 3:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3, _this2);
                }));

                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }(), function (error) {
                console.log(error);
              });

            case 2:
              return _context4.abrupt("return", _context4.sent);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this2);
    }))();
  },
  getUsuario: function getUsuario(id) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return instance.get("/users/id/" + id).then(function () {
                var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(response) {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _context5.next = 2;
                          return response.data;

                        case 2:
                          return _context5.abrupt("return", _context5.sent);

                        case 3:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5, _this3);
                }));

                return function (_x3) {
                  return _ref3.apply(this, arguments);
                };
              }(), function (error) {
                console.log(error);
              });

            case 2:
              return _context6.abrupt("return", _context6.sent);

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this3);
    }))();
  },
  saveUsuario: function saveUsuario(name, email, senha, acesso) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return instance.post("/users/register", {
                name: name,
                email: email,
                password: senha,
                acesso: acesso
              }).then(function () {
                var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(response) {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                    while (1) {
                      switch (_context7.prev = _context7.next) {
                        case 0:
                          _context7.next = 2;
                          return response.data;

                        case 2:
                          return _context7.abrupt("return", _context7.sent);

                        case 3:
                        case "end":
                          return _context7.stop();
                      }
                    }
                  }, _callee7, _this4);
                }));

                return function (_x4) {
                  return _ref4.apply(this, arguments);
                };
              }(), function (error) {
                console.log(error);
              });

            case 2:
              return _context8.abrupt("return", _context8.sent);

            case 3:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this4);
    }))();
  },
  alterarUsuario: function alterarUsuario(id, acesso, name) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return instance.put("/users/alterar/" + id, { acesso: acesso, name: name }).then(function () {
                var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(response) {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                    while (1) {
                      switch (_context9.prev = _context9.next) {
                        case 0:
                          _context9.next = 2;
                          return response.data;

                        case 2:
                          return _context9.abrupt("return", _context9.sent);

                        case 3:
                        case "end":
                          return _context9.stop();
                      }
                    }
                  }, _callee9, _this5);
                }));

                return function (_x5) {
                  return _ref5.apply(this, arguments);
                };
              }(), function (error) {
                console.log(error);
              });

            case 2:
              return _context10.abrupt("return", _context10.sent);

            case 3:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, _this5);
    }))();
  },
  deleteUser: function deleteUser(id) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return instance.delete("/users/remove/" + id).then(function () {
                var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(response) {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
                    while (1) {
                      switch (_context11.prev = _context11.next) {
                        case 0:
                          _context11.next = 2;
                          return response.data;

                        case 2:
                          return _context11.abrupt("return", _context11.sent);

                        case 3:
                        case "end":
                          return _context11.stop();
                      }
                    }
                  }, _callee11, _this6);
                }));

                return function (_x6) {
                  return _ref6.apply(this, arguments);
                };
              }(), function (error) {
                console.log(error);
              });

            case 2:
              return _context12.abrupt("return", _context12.sent);

            case 3:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, _this6);
    }))();
  },
  deleteContato: function deleteContato(id) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return instance.delete("/contatos/remove/" + id).then(function () {
                var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(response) {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
                    while (1) {
                      switch (_context13.prev = _context13.next) {
                        case 0:
                          _context13.next = 2;
                          return response.data;

                        case 2:
                          return _context13.abrupt("return", _context13.sent);

                        case 3:
                        case "end":
                          return _context13.stop();
                      }
                    }
                  }, _callee13, _this7);
                }));

                return function (_x7) {
                  return _ref7.apply(this, arguments);
                };
              }(), function (error) {
                console.log(error);
              });

            case 2:
              return _context14.abrupt("return", _context14.sent);

            case 3:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, _this7);
    }))();
  }
});

/***/ }),

/***/ 181:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_usuario__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_parameter__ = __webpack_require__(36);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',
  mixins: [__WEBPACK_IMPORTED_MODULE_2_vuelidate__["validationMixin"]],
  data: function data() {
    return {
      msg: 'Home',
      email: '',
      data: {},
      password: '',
      dialogMensagem: false,
      model: {},
      cards: {
        card1: "",
        card2: "",
        card3: ""
      },
      items: [{ text: "Lúcia Cantú / Beniamino Giovanni Baseggio", disabled: true }, { text: "Amália Baseggio" }, { text: "Marieta Baseggio" }, { text: "Alberto Baseggio" }, { text: "Ricardo Baseggio" }, { text: "Laurindo Baseggio" }, { text: "Primo Baseggio" }, { text: "Albina Baseggio" }, { text: "Angelo Baseggio" }, { text: "João Baseggio" }, { text: "Albino Baseggio" }, { text: "Estevão Baseggio" }, { text: "Ernesto Baseggio" }, { text: "Teresa Baseggio" }, { text: "Letícia Baseggio" }, { text: "Giovanni Maria Cantú / Santa Barbieri", disabled: true }, { text: "Ricieri José Cantú / Barbara Baioco" }, { text: "Maria Cantú / Angelo Locatelli" }, { text: "Guilherme Cantú / Maria Salvi" }, { text: "Domingos Cantú / Carolina Salvi" }, { text: "Victório Cantú" }, { text: "Vergílio Domingos Cantú / Melânia Defendi" }, { text: "Palmira Cantú / Luiz Salvi" }, { text: "Valéria Maghia Cantú / Augusto Mariani" }, { text: "Francisco Cantú / Davidica Pelissari" }, { text: "Cezare Cantú / Santina Pavan" }, { text: "Pietro Silvio Cantú / Santa Ferranti", disabled: true }, { text: "José Vergílio Cantú / Ana Maria Rigo / Dileta Morelato" }, { text: "Amante Cantú / Graciosa Noelo" }, { text: "Cezare Cantú /" }, { text: "João Domingos Cantú / Clélia Barichello" }, { text: "Valentim Cantú / Filomena Dal Pizzol" }, { text: "Linda Cantú / Isidoro Mamentini" }, { text: "Luiz Cantú / Maria Reck / Helena Biscaro" }, { text: "Valeria Cantú" }, { text: "Angelina Cantú / Carlos DallAgnol" }, { text: "Marieta Cantú / Vitório Guarda" }, { text: "Convidados" }]
    };
  },

  methods: {
    salvar: function salvar() {
      var _this = this;

      console.log(this.data);
      __WEBPACK_IMPORTED_MODULE_6__services_parameter__["a" /* default */].saveContato(this.data).then(function (res) {
        console.log(res);
        if (res.data && res.data.error) {
          _this.message = res.data.error.data;
          _this.dialogError = true;
        } else {
          _this.dialogMensagem = true;
        }
      });
    },
    submit: function submit() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$v.$touch();
                _context2.next = 3;
                return _this2.$store.dispatch('signUserIn', { username: _this2.email, password: _this2.password });

              case 3:
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_5__services_usuario__["a" /* default */].getUsuario(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.user._id).then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!(res.grand == "User")) {
                              _context.next = 5;
                              break;
                            }

                            _context.next = 3;
                            return _this2.$router.push('/descontos');

                          case 3:
                            _context.next = 7;
                            break;

                          case 5:
                            _context.next = 7;
                            return _this2.$router.push('/admin-home');

                          case 7:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this2);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  created: function created() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_6__services_parameter__["a" /* default */].getParameter().then(function (res) {
      if (res) {
        _this3.model = res;
        _this3.model.card1 = _this3.model.card1.replace(/(?:\r\n|\r|\n)/g, '<br>');
        _this3.model.card1 = _this3.model.card1.substring(0, 400) + '...';
      }
    });
  },

  watch: {
    user: function user(value) {
      /*if (value !== null && value !== undefined) {
        this.$router.push('/')
      }*/
    }
  },
  validations: {
    email: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["email"] },
    password: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] }
  },
  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    error: function error() {
      return this.$store.getters.error;
    },
    emailErrors: function emailErrors() {
      var errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push('Deve ser um e-mail válido');
      !this.$v.email.required && errors.push('Usuário deve ser informado');
      return errors;
    },
    passwordErrors: function passwordErrors() {
      var errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push('Senha deve ser informada');
      return errors;
    }
  }
});

/***/ }),

/***/ 183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HelloWorld',
  data: function data() {
    return {
      msg: 'Hello ' + this.$store.state.world,
      model: {}
    };
  },

  methods: {
    saveProduct: function saveProduct() {
      console.log(this.model);
      productsRef.push(this.model);
      this.clear();
    },
    clear: function clear() {
      this.model = {};
    }
  }
});

/***/ }),

/***/ 184:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_parameter__ = __webpack_require__(36);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HelloWorld',
  data: function data() {
    return {
      msg: 'Hello ' + this.$store.state.world,
      server: this.$store.getters.server,
      model: { card1: "" },
      descontos: [],
      message: "",
      dialog: false,
      dialogError: false,
      dialogConfirmation: false
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__services_parameter__["a" /* default */].getParameter().then(function (res) {
      _this.model = res;
      _this.model.card1 = _this.model.card1.replace(/(?:\r\n|\r|\n)/g, '<br>');
    });
  },

  methods: {
    sair: function sair() {
      this.$router.push('/logout');
    }
  }
});

/***/ }),

/***/ 185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HelloWorld',
  data: function data() {
    return {
      msg: 'Hello ' + this.$store.state.world,
      server: this.$store.getters.server,
      model: { name: "", endereco: "", telefone: "", descricao: "", desconto: 0 },
      descontos: [],
      message: "",
      dialog: false,
      dialogError: false,
      dialogConfirmation: false
    };
  },
  created: function created() {},

  methods: {}
});

/***/ }),

/***/ 186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_galeria__ = __webpack_require__(187);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Galeria',
  data: function data() {
    return {
      msg: 'Hello ' + this.$store.state.world,
      server: this.$store.getters.server,
      model: { name: "" },
      galerias: [],
      message: "",
      selected: {
        images: []
      },
      dialogImage: false,
      dialogImage2: false,
      carouselIndex: 1,
      dialog: false,
      dialogError: false,
      dialogConfirmation: false
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3__services_galeria__["a" /* default */].getGalerias();

            case 2:
              _this.galerias = _context.sent;

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    openGallery: function openGallery(item) {
      if (item) {
        this.selected = item;
        this.dialogImage = true;
      }
    },
    openImage: function openImage(img) {
      this.dialogImage2 = true;
      this.carouselIndex = img;
    },
    voltar: function voltar() {
      this.selected = [];
      this.dialogImage = false;
      this.dialogImage2 = false;
    }
  }
});

/***/ }),

/***/ 187:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(8);




var instance = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({ baseURL: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.server });

/* harmony default export */ __webpack_exports__["a"] = ({
  getGalerias: function getGalerias() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return instance.get("/galerias/get").then(function () {
                var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response) {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return response.data;

                        case 2:
                          return _context.abrupt("return", _context.sent);

                        case 3:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, _this);
                }));

                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }(), function (error) {
                console.log(error);
              });

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }))();
  },
  getGaleriaId: function getGaleriaId(id) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return instance.get("/galerias/get/" + id).then(function () {
                var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(response) {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return response.data;

                        case 2:
                          return _context3.abrupt("return", _context3.sent);

                        case 3:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3, _this2);
                }));

                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }(), function (error) {
                console.log(error);
              });

            case 2:
              return _context4.abrupt("return", _context4.sent);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this2);
    }))();
  },
  saveGaleriaImage: function saveGaleriaImage(model) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var config;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              console.log(model);
              config = { headers: { 'Content-Type': 'multipart/form-data' } };
              _context6.next = 4;
              return instance.post("/galerias/save", model, config).then(function () {
                var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(response) {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _context5.next = 2;
                          return response.data;

                        case 2:
                          return _context5.abrupt("return", _context5.sent);

                        case 3:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5, _this3);
                }));

                return function (_x3) {
                  return _ref3.apply(this, arguments);
                };
              }(), function (error) {
                console.log(error);
              });

            case 4:
              return _context6.abrupt("return", _context6.sent);

            case 5:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this3);
    }))();
  },
  removeGaleriaImage: function removeGaleriaImage(item, param) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return instance.delete("/galerias/removeImage/" + param + '/' + item.descricao);

            case 3:
              response = _context7.sent;
              return _context7.abrupt("return", response.data);

            case 7:
              _context7.prev = 7;
              _context7.t0 = _context7["catch"](0);

              console.log(_context7.t0);

            case 10:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this4, [[0, 7]]);
    }))();
  },
  removeGaleria: function removeGaleria(item) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 3;
              return instance.delete("/galerias/" + item._id);

            case 3:
              response = _context8.sent;
              return _context8.abrupt("return", response.data);

            case 7:
              _context8.prev = 7;
              _context8.t0 = _context8["catch"](0);

              console.log(_context8.t0);

            case 10:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this5, [[0, 7]]);
    }))();
  }
});

/***/ }),

/***/ 188:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HelloWorld',
  data: function data() {
    return {
      msg: 'Hello ' + this.$store.state.world,
      server: this.$store.getters.server,
      model: { name: "", endereco: "", telefone: "", descricao: "", desconto: 0 },
      descontos: [],
      message: "",
      dialog: false,
      dialogError: false,
      dialogConfirmation: false
    };
  },
  created: function created() {},

  methods: {}
});

/***/ }),

/***/ 189:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_usuario__ = __webpack_require__(12);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Signin',
  mixins: [__WEBPACK_IMPORTED_MODULE_2_vuelidate__["validationMixin"]],
  data: function data() {
    return {
      title: 'Signin',
      email: '',
      password: ''
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$v.$touch();
                _context.next = 3;
                return _this.$store.dispatch('signUserIn', { username: _this.email, password: _this.password });

              case 3:
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_5__services_usuario__["a" /* default */].getUsuario(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.user._id);

              case 5:
                res = _context.sent;

                if (res.grand == "Cliente") {
                  _this.$router.push('/');
                } else {
                  _this.$router.push('/admin/contatos');
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    clear: function clear() {
      this.$v.$reset();
      this.email = '';
      this.password = '';
      this.$router.push('/signup');
    },
    onDismissed: function onDismissed() {
      this.$store.dispatch('clearError');
    }
  },
  watch: {
    user: function user(value) {
      /*if (value !== null && value !== undefined) {
        this.$router.push('/admin/items')
      }*/
    }
  },
  validations: {
    email: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["email"] },
    password: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] }
  },
  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    error: function error() {
      return this.$store.getters.error;
    },
    emailErrors: function emailErrors() {
      var errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push('Must be valid e-mail');
      !this.$v.email.required && errors.push('E-mail is required');
      return errors;
    },
    passwordErrors: function passwordErrors() {
      var errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push('Password is required');
      return errors;
    }
  }
});

/***/ }),

/***/ 190:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Signin',
  mixins: [__WEBPACK_IMPORTED_MODULE_2_vuelidate__["validationMixin"]],
  data: function data() {
    return {
      title: 'Signin',
      email: '',
      password: ''
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$v.$touch();
                _context.next = 3;
                return _this.$store.dispatch('signUserUp', { email: _this.email, password: _this.password });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    clear: function clear() {
      this.$v.$reset();
      this.email = '';
      this.password = '';
    },
    onDismissed: function onDismissed() {
      this.$store.dispatch('clearError');
    }
  },
  watch: {
    user: function user(value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/hello');
      }
    }
  },
  validations: {
    email: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["email"] },
    password: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] }
  },
  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    error: function error() {
      return this.$store.getters.error;
    },
    emailErrors: function emailErrors() {
      var errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push('Must be valid e-mail');
      !this.$v.email.required && errors.push('E-mail is required');
      return errors;
    },
    passwordErrors: function passwordErrors() {
      var errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push('Password is required');
      return errors;
    }
  }
});

/***/ }),

/***/ 191:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_usuario__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  data: function data() {
    return {
      search: '',
      snackbar: false,
      message: '',
      loading: true,
      dialog: false,
      dialogError: false,
      dialogConfirmation: false,
      editando: false,
      excluindo: {},
      idZabbix: '',
      usuarios: [],
      options: ['Admin'],
      model: {
        name: "",
        username: "",
        senha: ""
      },
      headers: [{
        text: 'Nome',
        align: 'left',
        sortable: true,
        value: 'name'
      }, {
        text: 'Email',
        align: 'left',
        sortable: true,
        value: 'username'
      }, {
        text: 'Acesso',
        align: 'left',
        sortable: true,
        value: 'acesso'
      }, { text: 'Ações' }]
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__services_usuario__["a" /* default */].getUsuarios().then(function (res) {
      _this.usuarios = res;
    });
  },

  methods: {
    novo: function novo() {
      this.dialog = true;
      this.model = {
        name: "",
        username: "",
        password: ""
      };
    },
    deleteItem: function deleteItem(even) {
      var _this2 = this;

      if (!this.dialogConfirmation) {
        this.dialogConfirmation = true;
        this.excluindo = even;
      } else {
        __WEBPACK_IMPORTED_MODULE_0__services_usuario__["a" /* default */].deleteUser(even._id).then(function (res) {
          _this2.dialogConfirmation = false;
          _this2.excluindo = null;
          __WEBPACK_IMPORTED_MODULE_0__services_usuario__["a" /* default */].getUsuarios().then(function (res) {
            _this2.usuarios = res;
          });
        });
      }
    },
    editItem: function editItem(even) {
      //this.$router.push({ name: 'EditGroupHosts', params: { id: even.groupid }})
      this.dialog = true;
      this.editando = true;
      this.model = even;
      this.model.internal = undefined;
      this.model.flags = undefined;
      /*zabbix.getGroupHostsId(this.$route.params.id).then((res) => {
        this.model = res;
        this.model.internal = undefined;
        this.model.flags = undefined;
      });*/
    },
    save: function save() {
      var _this3 = this;

      this.$validator.validateAll().then(function (errors) {
        if (errors) {
          if (_this3.editando) {
            __WEBPACK_IMPORTED_MODULE_0__services_usuario__["a" /* default */].alterarUsuario(_this3.model._id, _this3.model.acesso, _this3.model.name).then(function (res) {
              if (res.data && res.data.error) {
                _this3.message = res.data.error.data;
                _this3.dialogError = true;
              } else {
                _this3.clear();
                __WEBPACK_IMPORTED_MODULE_0__services_usuario__["a" /* default */].getUsuarios().then(function (res) {
                  _this3.usuarios = res;
                });
              }

              _this3.editando = false;
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_0__services_usuario__["a" /* default */].saveUsuario(_this3.model.name, _this3.model.username, _this3.model.senha, _this3.model.acesso).then(function (res) {
              if (res.data && res.data.error) {
                _this3.message = res.data.error.data;
                _this3.dialogError = true;
              } else {
                _this3.clear();
                __WEBPACK_IMPORTED_MODULE_0__services_usuario__["a" /* default */].getUsuarios().then(function (res) {
                  _this3.usuarios = res;
                });
              }

              _this3.editando = false;
            });
          }
        }
      });
    },
    clear: function clear() {
      this.model = {
        name: "",
        username: "",
        password: ""
      };
      this.editando = false;
      this.$validator.reset();
      this.dialog = false;
    }

  }
});

/***/ }),

/***/ 192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_parameter__ = __webpack_require__(36);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "home",
  data: function data() {
    return {
      search: "",
      snackbar: false,
      message: "",
      loading: true,
      dialog: false,
      dialogError: false,
      dialogConfirmation: false,
      excluindo: {},
      idZabbix: "",
      usuarios: [],
      model: {
        name: ""
      },
      headers: [{
        text: "Nome",
        align: "left",
        sortable: true,
        value: "name"
      }, { text: "Ações" }],
      headersImagem: [{
        text: 'Nome Imagem',
        align: 'left',
        sortable: true,
        value: 'name'
      }, { text: 'Ações' }]
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__services_parameter__["a" /* default */].getParameter().then(function (res) {
      _this.model = res;
    });
  },

  methods: {
    save: function save() {
      var _this2 = this;

      console.log(this.model);
      __WEBPACK_IMPORTED_MODULE_2__services_parameter__["a" /* default */].saveParameter(this.model).then(function (res) {
        console.log(res);
        if (res.data && res.data.error) {
          _this2.message = res.data.error.data;
          _this2.dialogError = true;
        }
      });
    },
    deleteImage: function deleteImage(item) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__services_parameter__["a" /* default */].removeParamImage(item, _this3.model._id);

              case 2:
                res = _context.sent;

                __WEBPACK_IMPORTED_MODULE_2__services_parameter__["a" /* default */].getParameter().then(function (res) {
                  _this3.model = res;
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    onFileChange: function onFileChange($event) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var files, payload, i, file, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                files = $event.target.files || $event.dataTransfer.files;

                if (!files) {
                  _context2.next = 12;
                  break;
                }

                payload = new FormData();


                payload.set('param', _this4.model._id);

                if (!(files.length > 0)) {
                  _context2.next = 12;
                  break;
                }

                for (i = 0; i < files.length; i++) {
                  file = files[i];

                  payload.append('filename', file);
                }
                _context2.next = 8;
                return __WEBPACK_IMPORTED_MODULE_2__services_parameter__["a" /* default */].saveParamImage(payload);

              case 8:
                res = _context2.sent;
                _context2.next = 11;
                return __WEBPACK_IMPORTED_MODULE_2__services_parameter__["a" /* default */].getParameter();

              case 11:
                _this4.model = _context2.sent;

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    }
  }
});

/***/ }),

/***/ 193:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_galeria__ = __webpack_require__(187);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "home",
  data: function data() {
    return {
      search: "",
      snackbar: false,
      galeria: "",
      loading: true,
      dialog: false,
      dialogError: false,
      dialogConfirmation: false,
      excluindo: {},
      idZabbix: "",
      galerias: [],
      model: {},
      dialogImage: false,
      carregando: false,
      headersImagem: [{
        text: 'Nome Galeria',
        align: 'left',
        sortable: true,
        value: 'dsGaleria'
      }, { text: 'Ações' }],
      headersImages: [{
        text: 'Nome Galeria',
        align: 'left',
        sortable: true,
        value: 'descricao'
      }, { text: 'Ações' }]
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__services_galeria__["a" /* default */].getGalerias();

            case 2:
              _this.galerias = _context.sent;

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    addGalerias: function addGalerias() {
      if (!this.galerias || this.galerias.length == 0) {
        this.galerias = [];
      }
      if (this.galeria && this.galeria != '') {
        this.galerias.push({ dsGaleria: this.galeria });
        this.galeria = '';
      }
    },
    editImage: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(even) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.dialogImage = true;
                console.log(even);
                this.model = even;
                this.model.internal = undefined;
                this.model.flags = undefined;
                if (!this.model.images) {
                  this.model.images = [];
                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function editImage(_x) {
        return _ref.apply(this, arguments);
      }

      return editImage;
    }(),
    clearImage: function clearImage() {
      this.dialogImage = false;
      this.model = {};
    },
    deleteImage: function deleteImage(item) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__services_galeria__["a" /* default */].removeGaleriaImage(item, _this2.model._id);

              case 2:
                res = _context3.sent;

                __WEBPACK_IMPORTED_MODULE_2__services_galeria__["a" /* default */].getGaleriaId(_this2.model._id).then(function (res) {
                  _this2.model = res;
                });

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    deleteGaleria: function deleteGaleria(item) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__services_galeria__["a" /* default */].removeGaleria(item);

              case 2:
                res = _context4.sent;
                _context4.next = 5;
                return __WEBPACK_IMPORTED_MODULE_2__services_galeria__["a" /* default */].getGalerias();

              case 5:
                _this3.galerias = _context4.sent;

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    onFileChange: function onFileChange($event) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var files, payload, i, file, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:

                _this4.carregando = true;
                _context5.prev = 1;
                files = $event.target.files || $event.dataTransfer.files;

                if (!files) {
                  _context5.next = 17;
                  break;
                }

                payload = new FormData();

                console.log(_this4.model);
                payload.set('_id', _this4.model._id);
                payload.set('dsGaleria', _this4.model.dsGaleria);

                if (!(files.length > 0)) {
                  _context5.next = 17;
                  break;
                }

                for (i = 0; i < files.length; i++) {
                  file = files[i];

                  payload.append('filename', file);
                }
                _context5.next = 12;
                return __WEBPACK_IMPORTED_MODULE_2__services_galeria__["a" /* default */].saveGaleriaImage(payload);

              case 12:
                res = _context5.sent;
                _context5.next = 15;
                return __WEBPACK_IMPORTED_MODULE_2__services_galeria__["a" /* default */].getGaleriaId(_this4.model._id);

              case 15:
                _this4.model = _context5.sent;

                _this4.carregando = false;

              case 17:
                _context5.next = 22;
                break;

              case 19:
                _context5.prev = 19;
                _context5.t0 = _context5["catch"](1);

                _this4.carregando = false;

              case 22:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this4, [[1, 19]]);
      }))();
    }
  }
});

/***/ }),

/***/ 194:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_usuario__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  data: function data() {
    return {
      search: '',
      snackbar: false,
      message: '',
      loading: true,
      dialog: false,
      dialogError: false,
      dialogConfirmation: false,
      editando: false,
      excluindo: {},
      idZabbix: '',
      contatos: [],
      options: ['Admin'],
      data: {
        nome: "",
        endereco: "",
        nomemae: "",
        nomePai: ""
      },
      headers: [{
        text: 'Inscrição',
        align: 'center',
        sortable: true,
        value: 'numero'
      }, {
        text: 'Nome',
        align: 'left',
        sortable: true,
        value: 'nome'
      }, {
        text: 'Email',
        align: 'left',
        sortable: true,
        value: 'email'
      }, {
        text: 'Telefone',
        align: 'left',
        sortable: true,
        value: 'telefone'
      }, { text: 'Ações' }]
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__services_usuario__["a" /* default */].getContatos().then(function (res) {
      var num = 1;
      res.forEach(function (element) {
        element.numero = num++;
      });
      _this.contatos = res;
    });
  },

  methods: {
    deleteItem: function deleteItem(even) {
      var _this2 = this;

      if (!this.dialogConfirmation) {
        this.dialogConfirmation = true;
        this.excluindo = even;
      } else {
        __WEBPACK_IMPORTED_MODULE_0__services_usuario__["a" /* default */].deleteContato(even._id).then(function (res) {
          _this2.dialogConfirmation = false;
          _this2.excluindo = null;

          __WEBPACK_IMPORTED_MODULE_0__services_usuario__["a" /* default */].getContatos().then(function (res) {
            var num = 1;
            res.forEach(function (element) {
              element.numero = num++;
            });
            _this2.contatos = res;
          });
        });
      }
    },
    editItem: function editItem(even) {
      this.dialog = true;
      this.editando = true;
      this.data = even;
      this.data.internal = undefined;
      this.data.flags = undefined;
    },
    clear: function clear() {
      this.data = {
        nome: "",
        endereco: "",
        nomemae: "",
        nomePai: ""
      };
      this.editando = false;
      this.$validator.reset();
      this.dialog = false;
    }

  }
});

/***/ }),

/***/ 195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_dist_vuetify_css__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_dist_vuetify_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify_dist_vuetify_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuefire__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_moment__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_index__ = __webpack_require__(8);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuefire___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_moment___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_8__store_index__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_6__App__["a" /* default */] },
  created: function created() {
    this.$store.dispatch('init');
  }
});

/***/ }),

/***/ 200:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(38);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36929282_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(269);
function injectStyle (ssrContext) {
  __webpack_require__(205)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36929282_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 205:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppAlert_vue__ = __webpack_require__(52);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43f6ac4c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppAlert_vue__ = __webpack_require__(245);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppAlert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43f6ac4c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppAlert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"error":"","dismissible":"","value":true},on:{"input":_vm.onClose}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 58,
	"./af.js": 58,
	"./ar": 59,
	"./ar-dz": 60,
	"./ar-dz.js": 60,
	"./ar-kw": 61,
	"./ar-kw.js": 61,
	"./ar-ly": 62,
	"./ar-ly.js": 62,
	"./ar-ma": 63,
	"./ar-ma.js": 63,
	"./ar-sa": 64,
	"./ar-sa.js": 64,
	"./ar-tn": 65,
	"./ar-tn.js": 65,
	"./ar.js": 59,
	"./az": 66,
	"./az.js": 66,
	"./be": 67,
	"./be.js": 67,
	"./bg": 68,
	"./bg.js": 68,
	"./bm": 69,
	"./bm.js": 69,
	"./bn": 70,
	"./bn.js": 70,
	"./bo": 71,
	"./bo.js": 71,
	"./br": 72,
	"./br.js": 72,
	"./bs": 73,
	"./bs.js": 73,
	"./ca": 74,
	"./ca.js": 74,
	"./cs": 75,
	"./cs.js": 75,
	"./cv": 76,
	"./cv.js": 76,
	"./cy": 77,
	"./cy.js": 77,
	"./da": 78,
	"./da.js": 78,
	"./de": 79,
	"./de-at": 80,
	"./de-at.js": 80,
	"./de-ch": 81,
	"./de-ch.js": 81,
	"./de.js": 79,
	"./dv": 82,
	"./dv.js": 82,
	"./el": 83,
	"./el.js": 83,
	"./en-au": 84,
	"./en-au.js": 84,
	"./en-ca": 85,
	"./en-ca.js": 85,
	"./en-gb": 86,
	"./en-gb.js": 86,
	"./en-ie": 87,
	"./en-ie.js": 87,
	"./en-il": 88,
	"./en-il.js": 88,
	"./en-nz": 89,
	"./en-nz.js": 89,
	"./eo": 90,
	"./eo.js": 90,
	"./es": 91,
	"./es-do": 92,
	"./es-do.js": 92,
	"./es-us": 93,
	"./es-us.js": 93,
	"./es.js": 91,
	"./et": 94,
	"./et.js": 94,
	"./eu": 95,
	"./eu.js": 95,
	"./fa": 96,
	"./fa.js": 96,
	"./fi": 97,
	"./fi.js": 97,
	"./fo": 98,
	"./fo.js": 98,
	"./fr": 99,
	"./fr-ca": 100,
	"./fr-ca.js": 100,
	"./fr-ch": 101,
	"./fr-ch.js": 101,
	"./fr.js": 99,
	"./fy": 102,
	"./fy.js": 102,
	"./gd": 103,
	"./gd.js": 103,
	"./gl": 104,
	"./gl.js": 104,
	"./gom-latn": 105,
	"./gom-latn.js": 105,
	"./gu": 106,
	"./gu.js": 106,
	"./he": 107,
	"./he.js": 107,
	"./hi": 108,
	"./hi.js": 108,
	"./hr": 109,
	"./hr.js": 109,
	"./hu": 110,
	"./hu.js": 110,
	"./hy-am": 111,
	"./hy-am.js": 111,
	"./id": 112,
	"./id.js": 112,
	"./is": 113,
	"./is.js": 113,
	"./it": 114,
	"./it.js": 114,
	"./ja": 115,
	"./ja.js": 115,
	"./jv": 116,
	"./jv.js": 116,
	"./ka": 117,
	"./ka.js": 117,
	"./kk": 118,
	"./kk.js": 118,
	"./km": 119,
	"./km.js": 119,
	"./kn": 120,
	"./kn.js": 120,
	"./ko": 121,
	"./ko.js": 121,
	"./ky": 122,
	"./ky.js": 122,
	"./lb": 123,
	"./lb.js": 123,
	"./lo": 124,
	"./lo.js": 124,
	"./lt": 125,
	"./lt.js": 125,
	"./lv": 126,
	"./lv.js": 126,
	"./me": 127,
	"./me.js": 127,
	"./mi": 128,
	"./mi.js": 128,
	"./mk": 129,
	"./mk.js": 129,
	"./ml": 130,
	"./ml.js": 130,
	"./mn": 131,
	"./mn.js": 131,
	"./mr": 132,
	"./mr.js": 132,
	"./ms": 133,
	"./ms-my": 134,
	"./ms-my.js": 134,
	"./ms.js": 133,
	"./mt": 135,
	"./mt.js": 135,
	"./my": 136,
	"./my.js": 136,
	"./nb": 137,
	"./nb.js": 137,
	"./ne": 138,
	"./ne.js": 138,
	"./nl": 139,
	"./nl-be": 140,
	"./nl-be.js": 140,
	"./nl.js": 139,
	"./nn": 141,
	"./nn.js": 141,
	"./pa-in": 142,
	"./pa-in.js": 142,
	"./pl": 143,
	"./pl.js": 143,
	"./pt": 144,
	"./pt-br": 145,
	"./pt-br.js": 145,
	"./pt.js": 144,
	"./ro": 146,
	"./ro.js": 146,
	"./ru": 147,
	"./ru.js": 147,
	"./sd": 148,
	"./sd.js": 148,
	"./se": 149,
	"./se.js": 149,
	"./si": 150,
	"./si.js": 150,
	"./sk": 151,
	"./sk.js": 151,
	"./sl": 152,
	"./sl.js": 152,
	"./sq": 153,
	"./sq.js": 153,
	"./sr": 154,
	"./sr-cyrl": 155,
	"./sr-cyrl.js": 155,
	"./sr.js": 154,
	"./ss": 156,
	"./ss.js": 156,
	"./sv": 157,
	"./sv.js": 157,
	"./sw": 158,
	"./sw.js": 158,
	"./ta": 159,
	"./ta.js": 159,
	"./te": 160,
	"./te.js": 160,
	"./tet": 161,
	"./tet.js": 161,
	"./tg": 162,
	"./tg.js": 162,
	"./th": 163,
	"./th.js": 163,
	"./tl-ph": 164,
	"./tl-ph.js": 164,
	"./tlh": 165,
	"./tlh.js": 165,
	"./tr": 166,
	"./tr.js": 166,
	"./tzl": 167,
	"./tzl.js": 167,
	"./tzm": 168,
	"./tzm-latn": 169,
	"./tzm-latn.js": 169,
	"./tzm.js": 168,
	"./ug-cn": 170,
	"./ug-cn.js": 170,
	"./uk": 171,
	"./uk.js": 171,
	"./ur": 172,
	"./ur.js": 172,
	"./uz": 173,
	"./uz-latn": 174,
	"./uz-latn.js": 174,
	"./uz.js": 173,
	"./vi": 175,
	"./vi.js": 175,
	"./x-pseudo": 176,
	"./x-pseudo.js": 176,
	"./yo": 177,
	"./yo.js": 177,
	"./zh-cn": 178,
	"./zh-cn.js": 178,
	"./zh-hk": 179,
	"./zh-hk.js": 179,
	"./zh-tw": 180,
	"./zh-tw.js": 180
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 265;

/***/ }),

/***/ 267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);





var instance = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({ baseURL: "https://familiacantu-api.herokuapp.com" });
//const instance = axios.create({ baseURL: "http://localhost:8081" });

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    user: null,
    error: null,
    server: "https://familiacantu-api.herokuapp.com",
    loadingError: false,
    desconto: false
  },
  mutations: {
    setUser: function setUser(state, payload) {
      state.user = payload;
    },
    setDesconto: function setDesconto(state, payload) {
      state.desconto = payload;
    },
    setError: function setError(state, payload) {
      state.error = payload;
    }
  },
  actions: {
    init: function init(_ref, payload) {
      var _this = this;

      var commit = _ref.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var token, payload;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!localStorage.getItem("clube-token")) {
                  _context.next = 8;
                  break;
                }

                token = localStorage.getItem("clube-token");
                payload = JSON.parse(window.atob(token.split(".")[1]));
                _context.t0 = commit;
                _context.next = 6;
                return payload;

              case 6:
                _context.t1 = _context.sent;
                (0, _context.t0)("setUser", _context.t1);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    signUserUp: function signUserUp(_ref2, payload) {
      var _this2 = this;

      var commit = _ref2.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                commit("setLoading", true);
                commit("clearError");
                _context3.next = 4;
                return instance.post("/users/register", payload).then(function () {
                  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(user) {
                    var newUser, userNew;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            commit("setLoading", false);
                            newUser = {
                              id: user.uid,
                              name: payload.email,
                              email: payload.email,
                              photoUrl: user.photoURL
                            };
                            userNew = JSON.parse(window.atob(user.data.token.split(".")[1]));

                            localStorage.setItem("clube-token", user.data.token);
                            _context2.t0 = commit;
                            _context2.next = 7;
                            return userNew;

                          case 7:
                            _context2.t1 = _context2.sent;
                            (0, _context2.t0)("setUser", _context2.t1);

                          case 9:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this2);
                  }));

                  return function (_x) {
                    return _ref3.apply(this, arguments);
                  };
                }()).catch(function (error) {
                  commit("setLoading", false);
                  commit("setError", error);
                  console.log(error);
                });

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    signUserIn: function signUserIn(_ref4, payload) {
      var _this3 = this;

      var commit = _ref4.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                commit("setLoading", true);
                commit("clearError");
                _context5.next = 4;
                return instance.post("/users/login", payload).then(function () {
                  var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(user) {
                    var newUser, userNew;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            commit("setLoading", false);
                            newUser = {
                              id: user.uid,
                              name: payload.email,
                              email: payload.email,
                              photoUrl: user.photoURL
                            };
                            userNew = JSON.parse(window.atob(user.data.token.split(".")[1]));

                            localStorage.setItem("clube-token", user.data.token);
                            _context4.t0 = commit;
                            _context4.next = 7;
                            return userNew;

                          case 7:
                            _context4.t1 = _context4.sent;
                            (0, _context4.t0)("setUser", _context4.t1);

                          case 9:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4, _this3);
                  }));

                  return function (_x2) {
                    return _ref5.apply(this, arguments);
                  };
                }()).catch(function (error) {
                  console.log(error);
                  error = "Usuário ou senha invalido!";
                  commit("setLoading", false);
                  commit("setError", error);
                  console.log(error);
                });

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this3);
      }))();
    },
    signUserInGoogle: function signUserInGoogle(_ref6) {
      var commit = _ref6.commit;

      commit('setLoading', true);
      commit('clearError');
      firebase.getAuth().signInWithPopup(new firebase.getAuth().GoogleAuthProvider()).then(function (user) {
        commit('setLoading', false);
        var newUser = {
          id: user.uid,
          name: user.displayName,
          email: user.email,
          photoUrl: user.photoURL
        };
        commit('setUser', newUser);
      }).catch(function (error) {
        commit('setLoading', false);
        commit('setError', error);
        console.log(error);
      });
    },
    signUserInFacebook: function signUserInFacebook(_ref7) {
      var commit = _ref7.commit;

      commit('setLoading', true);
      commit('clearError');
      firebase.getAuth().signInWithPopup(new firebase.getAuth().FacebookAuthProvider()).then(function (user) {
        commit('setLoading', false);
        var newUser = {
          id: user.uid,
          name: user.displayName,
          email: user.email,
          photoUrl: user.photoURL
        };
        commit('setUser', newUser);
      }).catch(function (error) {
        commit('setLoading', false);
        commit('setError', error);
        console.log(error);
      });
    },
    signUserInGithub: function signUserInGithub(_ref8) {
      var commit = _ref8.commit;

      commit('setLoading', true);
      commit('clearError');
      firebase.getAuth().signInWithPopup(new firebase.getAuth().GithubAuthProvider()).then(function (user) {
        commit('setLoading', false);
        var newUser = {
          id: user.uid,
          name: user.displayName,
          email: user.email,
          photoUrl: user.photoURL
        };
        commit('setUser', newUser);
      }).catch(function (error) {
        commit('setLoading', false);
        commit('setError', error);
        console.log(error);
      });
    },
    signUserInTwitter: function signUserInTwitter(_ref9) {
      var commit = _ref9.commit;

      commit('setLoading', true);
      commit('clearError');
      firebase.getAuth().signInWithPopup(new firebase.getAuth().TwitterAuthProvider()).then(function (user) {
        commit('setLoading', false);
        var newUser = {
          id: user.uid,
          name: user.displayName,
          email: user.email,
          photoUrl: user.photoURL
        };
        commit('setUser', newUser);
      }).catch(function (error) {
        commit('setLoading', false);
        commit('setError', error);
        console.log(error);
      });
    },
    autoSignIn: function autoSignIn(_ref10, payload) {
      var commit = _ref10.commit;

      commit('setUser', {
        id: payload.uid,
        name: payload.displayName,
        email: payload.email,
        photoUrl: payload.photoURL
      });
    },
    desconto: function desconto(_ref11, payload) {
      var commit = _ref11.commit;

      commit("setDesconto", payload.val);
    },
    logout: function logout(_ref12) {
      var commit = _ref12.commit;

      localStorage.removeItem("clube-token");
      commit("setUser", null);
    }
  },
  getters: {
    user: function user(state) {
      return state.user;
    },
    server: function server(state) {
      return state.server;
    },
    desconto: function desconto(state) {
      return state.desconto;
    }
  }
});

/***/ }),

/***/ 268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    loading: false,
    error: null
  },
  mutations: {
    setLoading: function setLoading(state, payload) {
      state.loading = payload;
    },
    setError: function setError(state, payload) {
      state.error = payload;
    },
    clearError: function clearError(state) {
      state.error = null;
    }
  },
  actions: {
    clearError: function clearError(_ref) {
      var commit = _ref.commit;

      commit('clearError');
    }
  },
  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    error: function error(state) {
      return state.error;
    }
  }
});

/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[(_vm.isLoggin)?_c('v-navigation-drawer',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isDesconto),expression:"!isDesconto"}],attrs:{"clipped":_vm.$vuetify.breakpoint.lgAndUp,"fixed":"","app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',{attrs:{"dense":""}},[_vm._l((_vm.items),function(item){return [(item.heading)?_c('v-layout',{key:item.heading,attrs:{"row":"","align-center":""}},[_c('v-flex',{attrs:{"xs6":""}},[(item.heading)?_c('v-subheader',[_vm._v("\n              "+_vm._s(item.heading)+"\n            ")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs6":""}},[_c('a',{staticClass:"body-2 black--text",attrs:{"href":"#!"}},[_vm._v("EDIT")])])],1):(item.children)?_c('v-list-group',{key:item.text,attrs:{"prepend-icon":item.model ? item.icon : item['icon-alt'],"append-icon":""},model:{value:(item.model),callback:function ($$v) {_vm.$set(item, "model", $$v)},expression:"item.model"}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                "+_vm._s(item.text)+"\n              ")])],1)],1),_vm._v(" "),_vm._l((item.children),function(child,i){return _c('v-list-tile',{key:i,attrs:{"to":{name:child.link}}},[(child.icon)?_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(child.icon))])],1):_vm._e(),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                "+_vm._s(child.text)+"\n              ")])],1)],1)})],2):_c('v-list-tile',{key:item.text,attrs:{"to":{name:item.link}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n              "+_vm._s(item.text)+"\n            ")])],1)],1)]})],2)],1):_vm._e(),_vm._v(" "),_c('v-toolbar',{staticClass:"toolbar-titlew",class:[_vm.scrolled||_vm.isLoggin ? 'toolbar-shrink' : ''],attrs:{"clipped-left":_vm.$vuetify.breakpoint.lgAndUp,"color":"white","dark":"","app":"","center":"","fixed":""}},[_c('v-spacer'),_vm._v(" "),(!_vm.isLoggin)?_c('v-btn',{staticClass:"btn-menu",attrs:{"color":"transparent"}},[_c('span',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();_vm.home()}}},[_vm._v("INÍCIO")])]):_vm._e(),_vm._v(" "),(!_vm.isLoggin)?_c('v-btn',{staticClass:"btn-menu",attrs:{"color":"transparent"}},[_c('span',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();_vm.historia()}}},[_vm._v("HISTÓRIA")])]):_vm._e(),_vm._v(" "),(!_vm.isLoggin)?_c('v-btn',{staticClass:"btn-menu",attrs:{"color":"transparent"}},[_c('span',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();_vm.galeria()}}},[_vm._v("GALERIA DE FOTOS")])]):_vm._e(),_vm._v(" "),(!_vm.isLoggin)?_c('v-btn',{staticClass:"btn-menu",attrs:{"color":"transparent"}},[_c('span',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();_vm.arvore()}}},[_vm._v("ÁRVORE GENEALÓGICA")])]):_vm._e(),_vm._v(" "),(_vm.isLoggin)?_c('v-btn',{staticClass:"btn-menu",attrs:{"color":"transparent"}},[_c('span',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();return _vm.logout($event)}}},[_vm._v("Sair")])]):_vm._e(),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-content',{class:[!_vm.isLoggin||_vm.isDesconto ? 'content-main' : '']},[_c('router-view')],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.error),callback:function ($$v) {_vm.error=$$v},expression:"error"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Erro")]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.error))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},nativeOn:{"click":function($event){_vm.errorTest();}}},[_vm._v("Ok")])],1)],1)],1),_vm._v(" "),_c('v-footer',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoggin),expression:"!isLoggin"}]},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{staticClass:"barcode blue-grey",attrs:{"xs12":""}}),_vm._v(" "),_c('v-flex',{staticClass:"white footer toolbar-titlew",attrs:{"xs12":""}},[_c('v-spacer'),_vm._v(" "),(!_vm.isLoggin)?_c('v-btn',{staticClass:"btn-menu",attrs:{"color":"transparent"}},[_c('span',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();_vm.home()}}},[_vm._v("INÍCIO")])]):_vm._e(),_vm._v(" "),(!_vm.isLoggin)?_c('v-btn',{staticClass:"btn-menu",attrs:{"color":"transparent"}},[_c('span',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();_vm.historia()}}},[_vm._v("HISTÓRIA")])]):_vm._e(),_vm._v(" "),(!_vm.isLoggin)?_c('v-btn',{staticClass:"btn-menu",attrs:{"color":"transparent"}},[_c('span',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();_vm.encontro()}}},[_vm._v("III ENCONTRO BIENAL")])]):_vm._e(),_vm._v(" "),(!_vm.isLoggin)?_c('v-btn',{staticClass:"btn-menu",attrs:{"color":"transparent"}},[_c('span',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();_vm.galeria()}}},[_vm._v("GALERIA DE FOTOS")])]):_vm._e(),_vm._v(" "),(!_vm.isLoggin)?_c('v-btn',{staticClass:"btn-menu",attrs:{"color":"transparent"}},[_c('span',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();_vm.arvore()}}},[_vm._v("ÁRVORE GENEALÓGICA")])]):_vm._e(),_vm._v(" "),(_vm.isLoggin)?_c('v-btn',{staticClass:"btn-menu",attrs:{"color":"transparent"}},[_c('span',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();return _vm.logout($event)}}},[_vm._v("Sair")])]):_vm._e(),_vm._v(" "),_c('v-spacer')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Home__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_HelloWorld__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Historia__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Encontro__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Galeria__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Arvore__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_user_Signin__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_user_Signup__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_user_Usuarios__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_user_Params__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_user_GaleriaParam__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_user_Contatos__ = __webpack_require__(327);
















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  //mode: "history",
  routes: [{
    path: '/home-admin',
    name: 'HelloWorld',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_HelloWorld__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  }, {
    path: '/historia',
    name: 'Historia',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_Historia__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  }, {
    path: '/arvore',
    name: 'Arvore',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_Arvore__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  }, {
    path: '/galeria',
    name: 'Galeria',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_Galeria__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  }, {
    path: '/encontro',
    name: 'Encontro',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_Encontro__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  }, {
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_Home__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  }, {
    path: "/admin/usuarios",
    name: "Usuarios",
    component: __WEBPACK_IMPORTED_MODULE_11__pages_user_Usuarios__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  }, {
    path: "/admin/historia",
    name: "Params",
    component: __WEBPACK_IMPORTED_MODULE_12__pages_user_Params__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  }, {
    path: "/admin/galeria",
    name: "GaleriaParam",
    component: __WEBPACK_IMPORTED_MODULE_13__pages_user_GaleriaParam__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  }, {
    path: "/admin/contato",
    name: "Contatos",
    component: __WEBPACK_IMPORTED_MODULE_14__pages_user_Contatos__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  }, {
    path: '/signin',
    name: 'Signin',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_user_Signin__["a" /* default */]
  }, {
    path: '/signup',
    name: 'Signup',
    component: __WEBPACK_IMPORTED_MODULE_10__pages_user_Signup__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  }, {
    path: '/logout',
    name: 'Logout',
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__router_auth_guard__["a" /* default */]
  }]
}));

/***/ }),

/***/ 272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_usuario__ = __webpack_require__(12);



var _this = this;




/* harmony default export */ __webpack_exports__["a"] = ((function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(to.fullPath === "/logout")) {
              _context.next = 4;
              break;
            }

            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch("logout");
            next("/");
            return _context.abrupt("return");

          case 4:

            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('desconto', { val: false });
            if (!to.fullPath.includes("/admin")) {
              __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('desconto', { val: true });
            }
            _context.next = 8;
            return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch("init");

          case 8:
            if (!(to.fullPath.includes("admin") && !__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.user)) {
              _context.next = 11;
              break;
            }

            // if (store.getters.user) {
            //   next("/");
            //   return;
            // } else {
            next("/signin");
            return _context.abrupt("return");

          case 11:
            if (!__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.user) {
              _context.next = 16;
              break;
            }

            _context.next = 14;
            return __WEBPACK_IMPORTED_MODULE_3__services_usuario__["a" /* default */].getUsuario(__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.user._id).then(function (res) {
              if (!res) {
                __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch("logout");
              }
              if (res.grand == "Cliente" && to.fullPath.includes("/admin")) {

                next("/");
                return;
              } else if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.user) {
                next();
                return;
              } else {
                next("/home-admin");
                return;
              }
            });

          case 14:
            _context.next = 18;
            break;

          case 16:

            next();
            return _context.abrupt("return");

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
})());

/***/ }),

/***/ 273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(181);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80d16762_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(299);
function injectStyle (ssrContext) {
  __webpack_require__(274)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-80d16762"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80d16762_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 274:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"banner",attrs:{"id":"banner"}},[_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"janeiro white--text mb-3 text-xs-center",staticStyle:{"margin":"0 !important","width":"400px"}},[_vm._v("FEVEREIRO DE 2026")]),_vm._v(" "),_c('div',{staticClass:"encontro1 white--text mb-3 text-xs-center"},[_vm._v("V Encontro")])]),_vm._v(" "),_c('v-layout',{staticClass:"banner-bottom",attrs:{"column":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"familiacantu white--text mb-3 text-xs-center"},[_vm._v("Família Cantu")]),_vm._v(" "),_c('div',{staticClass:"brasil white--text mb-3 text-xs-center"},[_vm._v("NO BRASIL")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/Ativo 10@4x.png","alt":"FAMILIA CANTU","width":"460","height":"30"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/Ativo 12@4x.png","alt":"FAMILIA CANTU","width":"500","height":"20"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/Ativo 7@4x.png","alt":"FAMILIA CANTU","width":"500","height":"25"}})])],1),_vm._v(" "),_c('section',{staticClass:"banner3",attrs:{"id":"historia"}},[_c('v-layout',{staticClass:"mt-5 ml-5 mr-5",attrs:{"column":"","wrap":"","align-center":""}},[_c('v-flex',{staticClass:"mt-3 ml-3 mr-3",attrs:{"xs12":"","sm4":""}},[_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""}},[_c('p',{staticClass:"como-funciona"},[_c('span',[_vm._v(" Um pouco da ")])]),_vm._v(" "),_c('div',{staticClass:"historia black--text text-xs-center"},[_vm._v("NOSSA HISTÓRIA")]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card-text',{staticClass:"text-xs-center text-historia",domProps:{"innerHTML":_vm._s(_vm.model.card1)}})],1)],1),_vm._v(" "),_c('v-btn',{staticClass:"vejamais",attrs:{"href":"/#/historia"}},[_vm._v("\n            Veja mais\n          ")]),_vm._v(" "),_c('div',{staticClass:"banner-discendent hidden-xl-only text-xs-center"},[_vm._v("DISCENDENTI DI DOMENICO CANTÚ")]),_vm._v(" "),_c('div',{staticClass:"banner-discendent2 hidden-lg-and-down text-xs-center"},[_vm._v("DISCENDENTI DI DOMENICO CANTÚ")])],1)],1)],1)],1),_vm._v(" "),_c('section',{staticClass:"banner22 hidden-lg-and-down",attrs:{"id":"encontro"}},[_c('div',{staticClass:"encontro white--text text-xs-center"},[_vm._v("V ENCONTRO BIENAL FAMÍLIA CANTÚ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-xl":""}},[_c('v-layout',{staticClass:"my-5",staticStyle:{"margin-bottom":"0px !important","margin-top":"0px !important"},attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{staticClass:"cardencontro",staticStyle:{"height":"410px"},attrs:{"xs12":"","sm4":""}},[_c('v-card',{staticClass:"elevation-0 text-xs-center",staticStyle:{"height":"410px"}},[_c('v-card-title',{staticClass:"layout justify-center",staticStyle:{"padding-top":"60px"},attrs:{"primary-title":""}},[_c('div',{staticClass:"headlinencon2"},[_vm._v("Localização")])]),_vm._v(" "),_c('v-card-text',{staticClass:"trajan-pro3",staticStyle:{"font-size":"18px","padding":"0","margin-left":"auto","margin-right":"auto","width":"350px"}},[_vm._v("\n              SÃO MATEUS DO SUL - PR\n            ")]),_vm._v(" "),_c('v-card-text',{staticClass:"trajan-pro3",staticStyle:{"font-size":"18px","padding":"0","margin-left":"auto","margin-right":"auto","width":"350px"}},[_vm._v("\n              Samas Klub (Antigo CEPE) - Rua Manoel Cunha Bitencourt, 2100 - Vila Canoas\n            ")]),_vm._v(" "),_c('v-card-text',{staticClass:"trajan-pro3",staticStyle:{"font-size":"18px","padding":"0","margin-left":"auto","margin-right":"auto","width":"250px"}},[_vm._v("\n              15 de Fevereiro de 2026\n            ")]),_vm._v(" "),_c('div',{staticClass:"layout justify-center",staticStyle:{"padding-top":"10px"}},[_c('img',{attrs:{"src":"/static/img/Ativo 6@4x.png","alt":"FAMILIA CANTU","height":"10"}})]),_vm._v(" "),_c('v-card-title',{staticClass:"layout justify-center",staticStyle:{"padding-bottom":"0"},attrs:{"primary-title":""}},[_c('div',{staticClass:"headlinencon2"},[_vm._v("Informações")])]),_vm._v(" "),_c('v-card-text',{staticClass:"trajan-pro3",staticStyle:{"font-size":"30px","padding":"0","margin-left":"auto","margin-right":"auto","width":"200px"}},[_vm._v("\n              e contato\n            ")]),_vm._v(" "),_c('v-card-text',{staticClass:"trajan-pro3",staticStyle:{"padding":"0","margin-left":"auto","margin-right":"auto","width":"300px"}},[_vm._v("\n              contato@familiacantu.com.br\n            ")])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"py-0",attrs:{"xs12":"","sm4":""}},[_c('v-card',{staticClass:"elevation-0 img-local2"})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{staticClass:"cardencontro",staticStyle:{"padding-top":"0px !important","height":"410px"},attrs:{"xs12":"","sm4":""}},[_c('v-card',{staticClass:"elevation-0 text-xs-center",staticStyle:{"height":"410px","background-color":"#f9ba75"}},[_c('v-card-text',{staticClass:"trajan-pro3",staticStyle:{"font-size":"20px","padding":"0","padding-top":"80px","margin-left":"auto","margin-right":"auto","width":"300px"}},[_vm._v("\n              É com gratidão e alegria que, nós descendentes de Domeneco Cantú, convidamos a todos os familiares para o 5° Incontro da Família Cantú.\n            ")])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"cardencontro",staticStyle:{"padding-top":"0px !important","padding-left":"0px !important","height":"410px"},attrs:{"xs12":"","sm4":""}},[_c('v-card',{staticClass:"elevation-0 text-xs-center",staticStyle:{"height":"410px"}},[_c('v-card-text',{staticClass:"trajan-pro3",staticStyle:{"font-size":"30px","padding":"0","padding-top":"80px","margin-left":"auto","margin-right":"auto","width":"270px"}},[_vm._v("\n              Programação 5ª FESTA ANUAL FAMÍLIA CANTÚ\n            ")]),_vm._v(" "),_c('v-btn',{staticStyle:{"background-color":"#f9ba75","width":"114px","border-radius":"30%"},attrs:{"href":"/static/img/programacao-2026.pdf","target":"_blank"}},[_vm._v("\n              Confira\n            ")]),_vm._v(" "),_c('div',{staticClass:"layout justify-center",staticStyle:{"padding-top":"10px"}},[_c('img',{attrs:{"src":"/static/img/Ativo 6@4x.png","alt":"FAMILIA CANTU","height":"10"}})])],1)],1)],1)],1)],1),_vm._v(" "),_c('section',{staticClass:"banner2 hidden-xl-only"},[_c('div',{staticClass:"encontro white--text text-xs-center"},[_vm._v("III ENCONTRO BIENAL FAMÍLIA CANTÚ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-xl":""}},[_c('v-layout',{staticClass:"my-5",staticStyle:{"margin-bottom":"0px !important","margin-top":"0px !important"},attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-img',{staticClass:"img-fluid",attrs:{"src":"/static/img/programacao-2026.pdf","alt":"Convite"}})],1)],1)],1)],1),_vm._v(" "),_c('v-container',{attrs:{"grid-list-xl":""}},[_c('v-layout',{staticClass:"my-5",staticStyle:{"margin-bottom":"0px !important","margin-top":"0px !important"},attrs:{"row":"","wrap":"","justify-center":""}},[_c('iframe',{attrs:{"src":"https://docs.google.com/forms/d/e/1FAIpQLScvAobf976-dYJxwI6Sm4zl9wlYZ9AuPQUy_j4zSh-9aJaj9Q/viewform?embedded=true","width":"640","height":"573","frameborder":"0","marginheight":"0","marginwidth":"0"}},[_vm._v("Carregando…")])])],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogMensagem),callback:function ($$v) {_vm.dialogMensagem=$$v},expression:"dialogMensagem"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Parabéns")]),_vm._v(" "),_c('v-card-text',[_vm._v("Sua inscrição foi salva com sucesso. Se vemos no encontro!")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},nativeOn:{"click":function($event){_vm.dialogMensagem = false}}},[_vm._v("Ok")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelloWorld_vue__ = __webpack_require__(183);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95c39f68_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelloWorld_vue__ = __webpack_require__(302);
function injectStyle (ssrContext) {
  __webpack_require__(301)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-95c39f68"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelloWorld_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95c39f68_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelloWorld_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 301:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Historia_vue__ = __webpack_require__(184);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a116408_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Historia_vue__ = __webpack_require__(305);
function injectStyle (ssrContext) {
  __webpack_require__(304)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a116408"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Historia_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a116408_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Historia_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 304:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"banner"},[_c('v-layout',{staticClass:"banner-bottom",attrs:{"column":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"familiacantu white--text text-xs-center"},[_vm._v("Família Cantu")]),_vm._v(" "),_c('div',{staticClass:"brasil white--text text-xs-center"},[_vm._v("NO BRASIL")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/Ativo 10@4x.png","alt":"FAMILIA CANTU","width":"400","height":"25"}})])],1),_vm._v(" "),_c('section',{staticClass:"banner3"},[_c('v-layout',{staticClass:"mt-5 ml-5 mr-5",attrs:{"column":"","wrap":"","align-center":""}},[_c('v-flex',{staticClass:"mt-3 ml-3 mr-3",attrs:{"xs12":"","sm4":""}},[_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"historia text-xs-center"},[_vm._v("HISTÓRIA")]),_vm._v(" "),_c('hr',{staticClass:"historiahr"}),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","mt-5":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","offset-sm2":""}},[_c('v-layout',{attrs:{"wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card-text',{staticClass:"text-xs-center text-historia"},[_c('p',[_vm._v("Um pouco de história….")]),_vm._v(" "),_c('p',[_vm._v("No século XIX, a Itália, assim como grande parte da Europa, estava em ebulição. A Itália era um amontoado de estados independentes. Depois de trinta anos e várias tentativas, a unificação acontece e o novo reino entra numa profunda crise. O trabalho desaparece e a economia entra em colapso.")]),_vm._v(" "),_c('p',[_vm._v("É neste cenário que temos de imaginar o Domênico, o patriarca da família Cantú aqui no Brasil. Somado a isso, em Dezembro de 1881, morre seu pai Giovanni Maria, com 73 anos. Em seguida (38 dias após), em Janeiro de 1882, morre sua filha Maria Giuseppa (a quarta e última do casal), com 5 meses de idade. Nesta época, ainda estavam residindo em Antegnate,  (Via Sto Ambroasio, 15), Bérgamo, Itália.")]),_vm._v(" "),_c('p',[_vm._v("Com certeza, esta situação, aliada ao contexto do país, impulsionou a família a emigrar. Eram Domênico, a esposa Maria Valéria Podavite e os três filhos: Lúcia, Giovanni Maria e Pietro Sílvio.")]),_vm._v(" "),_c('p',[_vm._v("E, mal sabia Domênico que a partir desta sua decisão dava início a grande família Cantú no Brasil. Destes cinco pioneiros, nestes 120 anos, estima-se que nasceram mais de 1500 descendentes, hoje espalhados por todo país.")]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.model.card1)}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},_vm._l((_vm.model.images),function(item){return _c('div',{key:item},[_c('img',{staticStyle:{"margin-left":"50px"},attrs:{"src":item.image,"alt":"FAMILIA CANTU","height":"250"}})])}))],1)],1)],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Encontro_vue__ = __webpack_require__(185);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20ede72a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Encontro_vue__ = __webpack_require__(308);
function injectStyle (ssrContext) {
  __webpack_require__(307)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20ede72a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Encontro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20ede72a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Encontro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 307:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"banner"},[_c('v-layout',{staticClass:"banner-bottom",attrs:{"column":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"familiacantu white--text text-xs-center"},[_vm._v("Família Cantu")]),_vm._v(" "),_c('div',{staticClass:"brasil white--text text-xs-center"},[_vm._v("NO BRASIL")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/Ativo 10@4x.png","alt":"FAMILIA CANTU","width":"400","height":"25"}})])],1),_vm._v(" "),_c('section',{staticClass:"banner3"},[_c('v-layout',{staticClass:"mt-5 ml-5 mr-5",attrs:{"column":"","wrap":"","align-center":""}},[_c('v-flex',{staticClass:"mt-3 ml-3 mr-3",attrs:{"xs12":"","sm4":""}},[_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"historia text-xs-center"},[_vm._v("ENCONTRO ANUAL")]),_vm._v(" "),_c('hr',{staticClass:"historiahr"}),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","offset-sm2":""}},[_c('v-layout',{attrs:{"wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-card-text',{staticClass:"text-xs-center text-historia"},[_vm._v("\n                    Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh\n                    euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad\n                    minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor in hendrerit eum\n                    iriure dolor in hendrerit in in vulputate velit esse molestie consequat, vel illum\n                    dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio.\n                  ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('img',{attrs:{"src":"/static/img/Ativo 6@4x.png","alt":"FAMILIA CANTU","height":"10"}})])],1)],1)],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Galeria_vue__ = __webpack_require__(186);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f172c796_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Galeria_vue__ = __webpack_require__(311);
function injectStyle (ssrContext) {
  __webpack_require__(310)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f172c796"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Galeria_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f172c796_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Galeria_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 310:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 311:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"banner"},[_c('v-layout',{staticClass:"banner-bottom",attrs:{"column":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"familiacantu white--text text-xs-center"},[_vm._v("Família Cantu")]),_vm._v(" "),_c('div',{staticClass:"brasil white--text text-xs-center"},[_vm._v("NO BRASIL")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/Ativo 10@4x.png","alt":"FAMILIA CANTU","width":"400","height":"25"}})])],1),_vm._v(" "),_c('section',{staticClass:"banner3"},[_c('v-layout',{staticClass:"mt-5 ml-5 mr-5",attrs:{"column":"","wrap":"","align-center":""}},[_c('v-flex',{staticClass:"mt-3 ml-3 mr-3",attrs:{"xs12":"","sm4":""}},[_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"historia text-xs-center"},[_vm._v("GALERIA DE FOTOS")]),_vm._v(" "),_c('hr',{staticClass:"historiahr"}),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","offset-sm2":""}},[(!_vm.dialogImage)?_c('v-layout',{attrs:{"wrap":"","my-5":"","align-center":""}},_vm._l((_vm.galerias),function(item,k){return _c('v-flex',{key:k,staticClass:"my-1",attrs:{"xs12":"","sm4":""}},[_c('img',{staticClass:"cp",attrs:{"src":item.images[0].image,"alt":"FAMILIA CANTU","height":"200","width":"250"},on:{"click":function($event){$event.stopPropagation();_vm.openGallery(item)}}}),_vm._v(" "),_c('div',{staticClass:"text-imagem"},[_vm._v(_vm._s(item.dsGaleria))])])})):_vm._e()],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"70%"},model:{value:(_vm.dialogImage2),callback:function ($$v) {_vm.dialogImage2=$$v},expression:"dialogImage2"}},[_c('v-card',[_c('v-carousel',{model:{value:(_vm.carouselIndex),callback:function ($$v) {_vm.carouselIndex=$$v},expression:"carouselIndex"}},_vm._l((_vm.selected.images),function(item,x){return _c('v-carousel-item',{key:x,attrs:{"src":item.image}})}))],1)],1),_vm._v(" "),(_vm.dialogImage)?_c('v-container',[_c('div',{staticClass:"box_gallery"},[_c('v-btn',{staticClass:"vejamais",on:{"click":function($event){$event.stopPropagation();_vm.voltar()}}},[_vm._v("Voltar")])],1),_vm._v(" "),_c('div',{staticClass:"gallery",on:{"click":function($event){$event.stopPropagation();_vm.openImage(_vm.i)}}},_vm._l((_vm.selected.images),function(item,i){return _c('div',{key:i,staticClass:"gallery-panel"},[_c('img',{attrs:{"src":item.image,"alt":"FAMILIA CANTU","height":"200","width":"250"},on:{"click":function($event){$event.stopPropagation();_vm.openImage(i)}}})])}))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 312:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Arvore_vue__ = __webpack_require__(188);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc66d0a6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Arvore_vue__ = __webpack_require__(314);
function injectStyle (ssrContext) {
  __webpack_require__(313)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bc66d0a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Arvore_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc66d0a6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Arvore_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 313:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 314:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"banner"},[_c('v-layout',{staticClass:"banner-bottom",attrs:{"column":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"familiacantu white--text text-xs-center"},[_vm._v("Família Cantu")]),_vm._v(" "),_c('div',{staticClass:"brasil white--text text-xs-center"},[_vm._v("NO BRASIL")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/Ativo 10@4x.png","alt":"FAMILIA CANTU","width":"400","height":"25"}})])],1),_vm._v(" "),_c('section',{staticClass:"banner3"},[_c('v-layout',{staticClass:"mt-5 ml-5 mr-5",attrs:{"column":"","wrap":"","align-center":""}},[_c('v-flex',{staticClass:"mt-3 ml-3 mr-3",attrs:{"xs12":"","sm4":""}},[_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"historia text-xs-center"},[_vm._v("ÁRVORE GENEALÓGICA")]),_vm._v(" "),_c('hr',{staticClass:"historiahr"})])],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"img-arvore mt-5",attrs:{"column":"","align-center":"","justify-center":""}},[_c('v-layout',{attrs:{"wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card-text',{staticClass:"text-xs-center brasil1"},[_vm._v("Conheça a Árvore genealógica"),_c('br'),_vm._v("da família Cantu no Brasil")])],1)],1),_vm._v(" "),_c('v-btn',{staticClass:"vejamais",attrs:{"href":"/static/pdf/Arvore Genealógica Família Cantú.pdf","download":""}},[_vm._v("Acesse")])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 315:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signin_vue__ = __webpack_require__(189);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e53e7eba_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signin_vue__ = __webpack_require__(317);
function injectStyle (ssrContext) {
  __webpack_require__(316)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e53e7eba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e53e7eba_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 316:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 317:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"white--text",attrs:{"column":"","wrap":"","align-center":""}},[_c('v-container',{staticStyle:{"margin-top":"70px"},attrs:{"grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{staticClass:"my-3",attrs:{"xs12":"","sm6":"","offset-sm3":"","xl4":"","offset-xl4":""}},[_c('div',{staticClass:"text-xd-center text-md-center login"},[_c('h2',{staticClass:"headline mb-0 text-xd-center text-md-center diarioobra"},[_c('span',{staticClass:"diario"},[_vm._v("Familia Cantu")])]),_vm._v(" "),_c('v-card',{staticClass:"elevation-12"},[_c('v-card-text',{staticStyle:{"padding":"50px 50px 50px 50px"}},[_c('v-form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('h3',{staticClass:"headline mb-0 text-md-left text-login"},[_vm._v("Login")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-icon',{staticClass:"icon-input",attrs:{"dark":""}},[_vm._v("perm_identity")]),_vm._v(" "),_c('v-text-field',{staticClass:"input-login",attrs:{"label":"Usuário","hide-details":"","background-color":"gray","error-messages":_vm.emailErrors,"required":""},on:{"input":function($event){_vm.$v.email.$touch()},"blur":function($event){_vm.$v.email.$touch()}},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-icon',{staticClass:"icon-input",attrs:{"dark":""}},[_vm._v("lock")]),_vm._v(" "),_c('v-text-field',{staticClass:"input-login",attrs:{"label":"Senha","type":"password","hide-details":"","background-color":"gray","error-messages":_vm.passwordErrors,"required":""},on:{"input":function($event){_vm.$v.password.$touch()},"blur":function($event){_vm.$v.password.$touch()}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding":"0px 50px 50px 50px"}},[_c('v-btn',{staticClass:"text-transform-none",attrs:{"color":"primary","block":""},on:{"click":_vm.submit}},[_vm._v("Acessar")])],1)],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__ = __webpack_require__(190);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5538b129_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__ = __webpack_require__(320);
function injectStyle (ssrContext) {
  __webpack_require__(319)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5538b129"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5538b129_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 319:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"xs6":"","offset-xs3":"","sm4":"","offset-sm4":""}},[_c('v-card',{staticClass:"elevation-12"},[_c('v-card-text',[_c('v-form',[_c('h2',{staticClass:"headline mb-0 text-md-center"},[_vm._v("Clube Beneficios")]),_vm._v(" "),_c('h3',{staticClass:"headline mb-0 text-md-center"},[_vm._v("Registrar-se")]),_vm._v(" "),_c('v-text-field',{attrs:{"label":"E-mail","error-messages":_vm.emailErrors,"required":""},on:{"input":function($event){_vm.$v.email.$touch()},"blur":function($event){_vm.$v.email.$touch()}},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Password","type":"password","error-messages":_vm.passwordErrors,"required":""},on:{"input":function($event){_vm.$v.password.$touch()},"blur":function($event){_vm.$v.password.$touch()}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"text-transform-none",attrs:{"color":"primary"},on:{"click":_vm.submit}},[_vm._v("Registrar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Usuarios_vue__ = __webpack_require__(191);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d4cd81f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Usuarios_vue__ = __webpack_require__(322);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Usuarios_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d4cd81f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Usuarios_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md10":"","offset-md1":""}},[_c('v-card',[_c('v-card-title',[_vm._v("\n          Usuarios\n          "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Buscar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.usuarios,"search":_vm.search},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.username))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.acesso))]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){_vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){_vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])},[_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("\n            Your search for \""+_vm._s(_vm.search)+"\" found no results.\n          ")])],1),_vm._v(" "),_c('v-btn',{attrs:{"absolute":"","dark":"","fab":"","top":"","right":"","color":"pink"},on:{"click":function($event){_vm.novo()}}},[_c('v-icon',[_vm._v("add")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Cadastrar Usuário")])]),_vm._v(" "),_c('v-card-text',[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.save()}}},[_c('v-text-field',{attrs:{"label":"Nome","required":""},model:{value:(_vm.model.name),callback:function ($$v) {_vm.$set(_vm.model, "name", $$v)},expression:"model.name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Email","required":""},model:{value:(_vm.model.username),callback:function ($$v) {_vm.$set(_vm.model, "username", $$v)},expression:"model.username"}}),_vm._v(" "),(!_vm.editando)?_c('v-text-field',{attrs:{"label":"Password","type":"password","required":""},model:{value:(_vm.model.senha),callback:function ($$v) {_vm.$set(_vm.model, "senha", $$v)},expression:"model.senha"}}):_vm._e(),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.options,"label":"Acesso"},model:{value:(_vm.model.acesso),callback:function ($$v) {_vm.$set(_vm.model, "acesso", $$v)},expression:"model.acesso"}})],1)]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.clear()}}},[_vm._v("Fechar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.save()}}},[_vm._v("Salvar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogConfirmation),callback:function ($$v) {_vm.dialogConfirmation=$$v},expression:"dialogConfirmation"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Confirmação")]),_vm._v(" "),_c('v-card-text',[_vm._v("Tem certeza que deseja excluir?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},nativeOn:{"click":function($event){_vm.dialogConfirmation = false}}},[_vm._v("Não")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},nativeOn:{"click":function($event){_vm.deleteItem(_vm.excluindo)}}},[_vm._v("Sim")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Params_vue__ = __webpack_require__(192);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e652d85_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Params_vue__ = __webpack_require__(324);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Params_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e652d85_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Params_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md10":"","offset-md1":""}},[_c('v-card',[_c('v-card-title',[_vm._v("\n          Parâmetros\n          "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-textarea',{attrs:{"label":"Historia"},model:{value:(_vm.model.card1),callback:function ($$v) {_vm.$set(_vm.model, "card1", $$v)},expression:"model.card1"}}),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Cadastrar Imagens")])]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm12":"","md12":""}},[_c('input',{ref:"image",attrs:{"type":"file","accept":"image/*","multiple":true},on:{"change":_vm.onFileChange}})])],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headersImagem,"items":_vm.model.images},scopedSlots:_vm._u([{key:"items",fn:function(props2){return [_c('td',[_vm._v(_vm._s(props2.item.descricao))]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){_vm.deleteImage(props2.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])})],1),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.save();}}},[_vm._v(" Salvar ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GaleriaParam_vue__ = __webpack_require__(193);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01a565aa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GaleriaParam_vue__ = __webpack_require__(326);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GaleriaParam_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01a565aa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GaleriaParam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md10":"","offset-md1":""}},[_c('v-card',[_c('v-card-title',[_vm._v("\n          Galeria\n          "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Cadastrar Imagens")])]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm9":"","md9":""}},[_c('v-text-field',{attrs:{"label":"Nome Galeria","type":"text"},model:{value:(_vm.galeria),callback:function ($$v) {_vm.galeria=$$v},expression:"galeria"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm3":"","md3":""}},[_c('v-btn',{attrs:{"color":"blue darken-3","dark":""},on:{"click":function($event){_vm.addGalerias()}}},[_vm._v("+")])],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headersImagem,"items":_vm.galerias},scopedSlots:_vm._u([{key:"items",fn:function(props2){return [_c('td',[_vm._v(_vm._s(props2.item.dsGaleria))]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){_vm.editImage(props2.item)}}},[_c('v-icon',{staticClass:"mx-0",attrs:{"small":""}},[_vm._v("\n                      image\n                    ")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){_vm.deleteGaleria(props2.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"70%"},model:{value:(_vm.dialogImage),callback:function ($$v) {_vm.dialogImage=$$v},expression:"dialogImage"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Cadastrar Images")])]),_vm._v(" "),_c('v-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.carregando),expression:"carregando"}]},[_c('v-row',{staticClass:"fill-height",attrs:{"align-content":"center","justify":"center"}},[_c('v-col',{staticClass:"subtitle-1 text-center",attrs:{"cols":"12"}},[_vm._v("\n            Getting your files\n          ")]),_vm._v(" "),_c('v-col',{attrs:{"cols":"6"}},[_c('v-progress-linear',{attrs:{"color":"deep-purple accent-4","indeterminate":"","rounded":"","height":"6"}})],1)],1)],1),_vm._v(" "),_c('v-container',{directives:[{name:"show",rawName:"v-show",value:(!_vm.carregando),expression:"!carregando"}]},[_c('v-row',{staticClass:"fill-height",attrs:{"align-content":"center","justify":"center"}},[_c('v-col',{staticClass:"subtitle-1 text-center",attrs:{"cols":"12"}},[_c('input',{ref:"image",attrs:{"type":"file","accept":"image/*","multiple":true},on:{"change":_vm.onFileChange}})])],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headersImages,"items":_vm.model.images},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.descricao))]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){_vm.deleteImage(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1"},nativeOn:{"click":function($event){_vm.clearImage()}}},[_vm._v("Fechar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contatos_vue__ = __webpack_require__(194);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ac0a25c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contatos_vue__ = __webpack_require__(328);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contatos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ac0a25c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contatos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 328:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md10":"","offset-md1":""}},[_c('v-card',[_c('v-card-title',[_vm._v("\n          Inscrições\n          "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Buscar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.contatos,"search":_vm.search},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.numero))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.nome))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.telefone))]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){_vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("bookmark")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){_vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])},[_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("\n            Your search for \""+_vm._s(_vm.search)+"\" found no results.\n          ")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Inscrição")])]),_vm._v(" "),_c('v-card-text',[_vm._v("\n        Inscrição: "+_vm._s(_vm.data.numero)+" "),_c('br'),_vm._v("\n        Nome: "+_vm._s(_vm.data.nome?_vm.data.nome.toUpperCase():'')+" "),_c('br'),_vm._v("\n        Ramo: "+_vm._s(_vm.data.ramo)+" "),_c('br'),_vm._v("\n        Nascimento: "+_vm._s(_vm.data.dtNascimento)+" "),_c('br'),_vm._v("\n        Nome Pai: "+_vm._s(_vm.data.nomePai?_vm.data.nomePai.toUpperCase():'')+" "),_c('br'),_vm._v("\n        Nome da Mãe: "+_vm._s(_vm.data.nomemae?_vm.data.nomemae.toUpperCase():'')+" "),_c('br'),_vm._v("\n        Local de Nascimento: "+_vm._s(_vm.data.localNascimento)+" "),_c('br'),_vm._v("\n        Conjuge: "+_vm._s(_vm.data.conjuge)+" "),_c('br'),_vm._v("\n        Data Casamento: "+_vm._s(_vm.data.dtCasamento)+" "),_c('br'),_vm._v("\n        Endereço: "+_vm._s(_vm.data.endereco?_vm.data.endereco.toUpperCase():'')+" "),_c('br'),_vm._v("\n        Email: "+_vm._s(_vm.data.email)+" "),_c('br'),_vm._v("\n        Telefone: "+_vm._s(_vm.data.telefone)+"\n      ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.clear()}}},[_vm._v("Fechar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogConfirmation),callback:function ($$v) {_vm.dialogConfirmation=$$v},expression:"dialogConfirmation"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Confirmação")]),_vm._v(" "),_c('v-card-text',[_vm._v("Tem certeza que deseja excluir?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},nativeOn:{"click":function($event){_vm.dialogConfirmation = false}}},[_vm._v("Não")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},nativeOn:{"click":function($event){_vm.deleteItem(_vm.excluindo)}}},[_vm._v("Sim")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(8);




var instance = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({ baseURL: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.server });

/* harmony default export */ __webpack_exports__["a"] = ({
  getParameter: function getParameter() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return instance.get("/parameters/get").then(function () {
                var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response) {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return response.data;

                        case 2:
                          return _context.abrupt("return", _context.sent);

                        case 3:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, _this);
                }));

                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }(), function (error) {
                console.log(error);
              });

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }))();
  },
  saveContato: function saveContato(model) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return instance.post("/contatos/save", model).then(function () {
                var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(response) {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          console.log(response);
                          _context3.next = 3;
                          return response.data;

                        case 3:
                          return _context3.abrupt("return", _context3.sent);

                        case 4:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3, _this2);
                }));

                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }(), function (error) {
                console.log(error);
              });

            case 2:
              return _context4.abrupt("return", _context4.sent);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this2);
    }))();
  },
  saveParameter: function saveParameter(model) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return instance.post("/parameters/save", model).then(function () {
                var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(response) {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          console.log(response);
                          _context5.next = 3;
                          return response.data;

                        case 3:
                          return _context5.abrupt("return", _context5.sent);

                        case 4:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5, _this3);
                }));

                return function (_x3) {
                  return _ref3.apply(this, arguments);
                };
              }(), function (error) {
                console.log(error);
              });

            case 2:
              return _context6.abrupt("return", _context6.sent);

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this3);
    }))();
  },
  saveParamImage: function saveParamImage(model) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var config;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              console.log(model);
              config = { headers: { 'Content-Type': 'multipart/form-data' } };
              _context8.next = 4;
              return instance.post("/parameters/saveImage", model, config).then(function () {
                var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(response) {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                    while (1) {
                      switch (_context7.prev = _context7.next) {
                        case 0:
                          _context7.next = 2;
                          return response.data;

                        case 2:
                          return _context7.abrupt("return", _context7.sent);

                        case 3:
                        case "end":
                          return _context7.stop();
                      }
                    }
                  }, _callee7, _this4);
                }));

                return function (_x4) {
                  return _ref4.apply(this, arguments);
                };
              }(), function (error) {
                console.log(error);
              });

            case 4:
              return _context8.abrupt("return", _context8.sent);

            case 5:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this4);
    }))();
  },
  removeParamImage: function removeParamImage(item, param) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              _context9.next = 3;
              return instance.delete("/parameters/removeImage/" + item._id + '/' + param);

            case 3:
              response = _context9.sent;
              return _context9.abrupt("return", response.data);

            case 7:
              _context9.prev = 7;
              _context9.t0 = _context9["catch"](0);

              console.log(_context9.t0);

            case 10:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, _this5, [[0, 7]]);
    }))();
  }
});

/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_AppAlert__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_usuario__ = __webpack_require__(12);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AppAlert: __WEBPACK_IMPORTED_MODULE_2__components_shared_AppAlert__["a" /* default */]
  },
  data: function data() {
    return {
      drawer: null,
      title: 'Vuetify.js',
      scrolled: false,
      dialogError: false
    };
  },

  methods: {
    submit: function submit(formData) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch("signUserIn", {
                  username: formData.name,
                  password: formData.password
                });

              case 2:
                _context.next = 4;
                return _this.$router.push("/descontos");

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    errorTest: function errorTest() {
      this.dialogError = false;
      this.$store.dispatch('clearError');
    },
    onDismissed: function onDismissed() {
      this.$store.dispatch('clearError');
    },
    home: function home() {
      this.$router.push('/');
    },
    historia: function historia() {
      this.$router.push('/historia');
    },
    encontro: function encontro() {
      this.$router.push('/');
      this.scrollMeTo("encontro");
    },
    galeria: function galeria() {
      this.$router.push('/galeria');
    },
    arvore: function arvore() {
      this.$router.push('/arvore');
    },
    logout: function logout() {
      this.$router.push('/logout');
    },
    handleScroll: function handleScroll() {
      if (this.$store.getters.user) {
        this.scrolled = true;
      } else {
        this.scrolled = window.scrollY > 0;
      }
    },
    scrollMeTo: function scrollMeTo(refName) {
      /*var element = this.$refs[refName];
      console.log(element);
      var top = element.offsetTop;
      window.scrollTo(0, top);*/
      var container = document.body;
      var element = document.getElementById(refName);
      element.scrollIntoView();
      //console.log(element.offset().top);

      //window.scrollTo(0, element.offsetTop);
      //container.scrollTop = element.offsetTop;
    }
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  computed: {
    error: function error() {
      if (this.$store.getters.error) {
        this.dialogError = true;
      } else {
        this.dialogError = false;
      }
      return this.$store.getters.error;
    },
    isLoggin: function isLoggin() {
      return this.$store.getters.user ? true : false;
    },
    isDesconto: function isDesconto() {
      console.log(this.$store.getters.desconto);
      return this.$store.getters.desconto;
    },
    isUser: function isUser() {
      if (!this.$store.getters.user) {
        return false;
      } else {
        __WEBPACK_IMPORTED_MODULE_3__services_usuario__["a" /* default */].getUsuario(this.$store.getters.user._id).then(function (res) {
          if (res != null && res.grand == "User") {
            return false;
          } else {
            return true;
          }
        });
      }
    },
    items: function items() {
      var items = [{
        icon: "keyboard_arrow_up",
        "icon-alt": "keyboard_arrow_down",
        text: "Configurações",
        modelConf: false,
        children: [{
          icon: "perm_contact_calendar",
          text: "Usuários",
          link: "Usuarios"
        }, { icon: "book", text: "Historia", link: "Params" }, { icon: "insert_photo", text: "Galeria", link: "GaleriaParam" }, { icon: "book", text: "Inscrições", link: "Contatos" }]
      }];
      return items;
    },
    menus: function menus() {
      var menus = [{
        icon: 'home',
        title: 'Registrar',
        to: '/signup'
      }, {
        icon: 'label',
        title: 'Entrar',
        to: '/signin'
      }];
      if (this.$store.getters.user) {
        menus = [{
          icon: 'label',
          title: 'Logout',
          to: '/logout'
        }];
      }
      return menus;
    }
  }
});

/***/ }),

/***/ 52:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['text'],
  methods: {
    onClose: function onClose() {
      this.$emit('dismissed');
    }
  }
});

/***/ }),

/***/ 8:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_user__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_common__ = __webpack_require__(268);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    user: __WEBPACK_IMPORTED_MODULE_2__store_user__["a" /* default */],
    common: __WEBPACK_IMPORTED_MODULE_3__store_common__["a" /* default */]
  },

  state: {
    world: 'world'
  },

  actions: {},

  mutations: {},

  getters: {}
}));

/***/ })

},[195]);


// WEBPACK FOOTER //
// static/js/app.a0ad3e8a28627c265490.js